import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { volumes } from '../../data/content';
export function VolumesSection() {
  return <section className="w-full bg-white" data-id="element-322" data-mp="2mux0rv2u6qi0">
      <div className="mx-auto w-full max-w-content px-5 py-14 sm:px-8 sm:py-20" data-id="element-323" data-mp="2mtvh527r8voo">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-teal" data-id="element-324" data-mp="2rt6yodfy457b">
          All’interno del Progetto
        </p>
        <h2 className="mt-3 text-balance text-center font-display text-[30px] font-black leading-[1.1] tracking-[-0.02em] text-plum-deep sm:text-4xl" data-id="element-325" data-mp="2e1a668ad7tae">
          Cosa include il Progetto Clinico della Menopausa™
        </h2>

        <div className="mx-auto mt-6 max-w-2xl space-y-3 text-center" data-id="element-326" data-mp="293i7mvf7t8x8">
          <p className="text-[15.5px] leading-relaxed text-ink/70 sm:text-base" data-id="element-327" data-mp="293s14szgxy7o">
            Questo non è un singolo PDF. È un sistema completo per il processo decisionale clinico,
            progettato per guidarti in ogni fase della gestione della menopausa, dalla consultazione
            iniziale al follow-up a lungo termine.
          </p>
          <p className="text-[15px] font-semibold text-plum sm:text-base" data-id="element-328" data-mp="1akozk3hhahos">
            Ogni volume elimina l’incertezza. Ogni framework semplifica il processo decisionale.
            Ogni algoritmo ti aiuta a esercitare con maggiore sicurezza.
          </p>
        </div>

        <h3 className="mt-12 text-center font-display text-[22px] font-black leading-tight text-plum-deep sm:text-2xl" data-id="element-329" data-mp="wssa67772lw3">
          I sei volumi del Progetto Clinico della Menopausa™
        </h3>

        <div className="mt-7 grid gap-5 lg:grid-cols-2 lg:gap-6" data-id="element-330" data-mp="rruuc19nq3xr">
          {volumes.map(volume => <article key={volume.number} className="flex flex-col overflow-hidden rounded-3xl bg-cream ring-1 ring-ink/10" data-id="element-331" data-mp="11rvgduywuy5n">
              <div className="bg-plum px-5 py-3 sm:px-7" data-id="element-332" data-mp="e0ga5r40jwp4">
                <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-white/80" data-id="element-333" data-mp="93zmsz4n1md3">
                  {volume.number}
                </p>
              </div>

              <div className="flex flex-1 flex-col p-5 sm:p-7" data-id="element-334" data-mp="12sxbkpvnf7n5">
                <h4 className="font-display text-[21px] font-black leading-tight text-plum-deep sm:text-[23px]" data-id="element-335" data-mp="12r44j9h4ilem">
                  {volume.title}
                </h4>
                <p className="mt-3 text-[15px] font-semibold leading-snug text-ink/80 sm:text-base" data-id="element-336" data-mp="1choz8ltof5s9">
                  {volume.lead}
                </p>
                <p className="mt-2.5 text-[14.5px] leading-relaxed text-ink/65 sm:text-[15px]" data-id="element-337" data-mp="fuu5eiomalel">
                  {volume.body}
                </p>

                <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[0.14em] text-teal" data-id="element-338" data-mp="os4djv651ufa">
                  {volume.listTitle}
                </p>
                <ul className="mt-3 space-y-2" data-id="element-339" data-mp="208b649ry2k0o">
                  {volume.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-340" data-mp="257fe4x34ubpf">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-341" data-mp="255kwpsr2l1q3" />
                      <span className="text-[14.5px] font-medium leading-snug text-ink/75" data-id="element-342" data-mp="3prj6ocqml02t">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-343" data-mp="3b00u6owz5no7">
          <CTAButton label="Sblocca ora tutti i 6 volumi" sub="Valore 297 € — oggi solo 19 €" variant="plum" data-id="element-344" data-mp="36yp30eygcudw" />
        </div>
      </div>
    </section>;
}